import styles from './template.css';
import template from './template';
import {AoflElement, property, customElement} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';
import translations from '../i18n';
/**
 * @summary LegendElement
 * @extends {AoflElement}
 */
@customElement('legend-element')
class LegendElement extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of LegendElement.
   */
  constructor() {
    super();
    this.translations = translations;
  }

  @property({type: Array})
  legend = [];

  /**
   * @readonly
   */
  static is = 'legend-element';

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default LegendElement;
